<template>
  <b-nav-item-dropdown right menu-class="dropdown-min-width" no-caret>
    <template #button-content>
      <img
          width="20"
          style="margin-right: 5px"
          :src="icons[$i18n.locale]"
          :alt="`${$i18n.locale} Flag`"
      >
      <span
          class="align-items-center"
          :class="(scrollPosition > 50) ? 'text-black' :'  text-white'"
      >
        {{ text[$i18n.locale] }}
      </span>
    </template>

    <template v-for="(locale, index) in $i18n.availableLocales">
      <b-dropdown-item
          :key="'app locale' + locale"
          :disabled="$i18n.locale === locale"
          @click="changeLocale(locale)"
      >
        <img
            style="margin-right: 5px; width: 20px;"
            :src="icons[locale]"
            :alt="`${locale} Flag`"
        >
        {{ text[locale] }}
      </b-dropdown-item>

      <b-dropdown-divider v-if="index + 1 !== $i18n.availableLocales.length"></b-dropdown-divider>
    </template>

  </b-nav-item-dropdown>
</template>

<script>
import RUIcon from '@/assets/images/lang/ru.png';
import UZIcon from '@/assets/images/lang/uz.png';
import EnIcon from '@/assets/images/lang/en.png';

export default {
  name: 'TheLangPicker',
  props: ['scrollPosition'],
  data: () => ({
    icons: {
      ru: RUIcon,
      uz: UZIcon,
      en: EnIcon,
    },
    text: {
      ru: 'Рус',
      uz: 'O\'zb',
      en: 'Eng',
    },
  }),
  methods: {
    changeLocale(locale) {
      localStorage.setItem('locale', locale);
      this.$i18n.locale = locale;
    },
  },
};
</script>

<style scoped lang="scss"></style>